<template>
  <div>
    <gmap-map
        ref="gmap"
        :center="{lat: this.lat, lng: this.lng}"
        :zoom="zoom"
        map-type-id="roadmap"
        style="width: 100%; height: 600px"
    >
      <gmap-cluster :maxZoom="15">
        <gmap-marker
            v-for="(m, index) in adjustedMarkers"
            :key="m.id"
            @click="showInfoWindow(m)"
            :draggable="false"
            :position="{lat: m.lat, lng: m.lng}"
        >
          <gmap-info-window
              :options="infoOptions"
              :opened="m.id === currentMarkerId && infoWindowShown"
              @closeclick="closeInfoWindow"
              :position="{lat: m.lat, lng: m.lng}">
            <div>
              <a :href="infoWindowLink">{{ infoWindowContent }}</a>
            </div>
            <span class="font-weight-bold">
              {{ 'map.event_date_at_x_oclock' | trans({date: infoWindowDate}) }}
            </span>
          </gmap-info-window>
        </gmap-marker>
      </gmap-cluster>
    </gmap-map>
  </div>
</template>

<script>
import moment from "moment";
import GmapCluster from 'vue2-google-maps/dist/components/cluster'

export default {
  components: {
    GmapCluster
  },
  props: {
    lat: {
      default: 50
    },
    lng: {
      default: 9
    },
    zoom: {
      default: 6
    },
    entries: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {
      markers: this.entries,
      infoWindowShown: false,
      infoWindowContent: "",
      currentMarkerId: null,
      infoWindowDate: "",
      infoWindowLink: "",
      visibleMarkerIds: [],
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -40
        },
        // disableAutoPan: true
      },
    };
  },
  computed: {
    adjustedMarkers() {
      const offsetDistance = 0.000045; // 5 Meter Offset
      const groupedMarkers = this.groupMarkersByPosition(this.markers);
      return groupedMarkers.flatMap((group) => {
        if (group.length === 1) {
          return group;
        } else {
          const angleStep = (2 * Math.PI) / group.length;
          return group.map((marker, index) => {
            const angle = angleStep * index;
            const latOffset = offsetDistance * Math.cos(angle);
            const lngOffset = offsetDistance * Math.sin(angle);
            return {
              ...marker,
              lat: marker.lat + latOffset,
              lng: marker.lng + lngOffset,
            };
          });
        }
      });
    },
    encodedVisibleMarkerIds() {
      return this.visibleMarkerIds.join(',');
    },
    isAuthorizedUser() {
      const userId = document.querySelector('meta[name="user-id"]')?.getAttribute('content');
      return userId === '12059' || userId === '12068';
    }
  },
  methods: {
    groupMarkersByPosition(markers) {
      const positionMap = new Map();
      markers.forEach((marker) => {
        const key = `${marker.lat.toFixed(6)}_${marker.lng.toFixed(6)}`;
        if (!positionMap.has(key)) {
          positionMap.set(key, []);
        }
        positionMap.get(key).push(marker);
      });
      return Array.from(positionMap.values());
    },
    showInfoWindow(marker) {
      this.currentMarkerId = marker.id;
      this.infoWindowContent = marker.title;
      this.infoWindowLink = marker.url;
      this.dateFormat = process.env.MIX_PLATFORM === "openings24" ? "MM/DD/YYYY h:mm A" : "DD.MM.YYYY HH:mm";
      this.infoWindowDate = moment(marker.event_date_start).format(this.dateFormat);
      this.infoWindowShown = true;
    },
    closeInfoWindow() {
      this.infoWindowShown = false;
      this.currentMarkerId = null;
    },
    getVisibleMarkerIds() {
      const map = this.$refs.gmap.$mapObject;
      const bounds = map.getBounds();

      this.visibleMarkerIds = this.markers
          .filter(marker => bounds.contains({lat: marker.lat, lng: marker.lng}))
          .map(marker => marker.id);
    },
    submitForm() {
      this.getVisibleMarkerIds();
      this.$nextTick(() => {
        this.$el.querySelector('form').submit();
      });
    }
  }
};
</script>
